export const STATE = {
    EXPANDED: 'expanded',
    CLOSED: 'closed',
    HALF_EXPANDED: 'half-expanded'
}

/**
 * Fired when a points bubble finishes flying into the navbar bell. Carries
 * `{ amount }`. The Dialog uses it to light the badge, the Navbar to ring the
 * bell - both optimistic, ahead of the `brain__score-updated` push.
 */
export const POINTS_EARNED = 'gamedash:points-earned';

/** Value of `data-fly-target` on the navbar bell icons. */
export const BELL_FLY_TARGET = 'gamedash-bell';

/**
 * Fired when any real-time gamedash push lands (highlight, neuron earned,
 * score updated). The Dialog uses it to light the bell badge: the score diff
 * alone only moves when the brain score itself changes, so pushes that add a
 * highlight or a neuron would otherwise arrive with no visible signal.
 */
export const ACTIVITY_RECEIVED = 'gamedash:activity-received';

/**
 * Asks the navbar's Game Dash dialog to open itself. Carries
 * `{ nudge, scope, delay }` - see `/app/composables/gamedash-nudge`. The Dialog
 * is the only listener: it owns the modal, so it also owns the once-per-user /
 * once-per-session bookkeeping, and nothing gets marked as shown from a page
 * where the dash could not have opened (signed out, dialog unmounted).
 */
export const OPEN_REQUESTED = 'gamedash:open-requested';

/**
 * Fired when the closing Game Dash finishes its travel and lands on the bell.
 * The Navbar rings on it, the same reaction a points bubble gets - the panel
 * arriving and a dot arriving are the same event as far as the bell is
 * concerned, and the ring is what makes the destination unmissable.
 */
export const DASH_LANDED = 'gamedash:landed';

/**
 * Players below this overall brain level count as newbies and see the inline
 * Game Dash widget without pinning it.
 */
export const NEWBIE_LEVEL_LIMIT = 2;

/** Why the inline Game Dash widget is on screen (`reason` on its analytics). */
export const WIDGET_REASON = {
    NEWBIE: 'newbie',
    PINNED: 'pinned',
};
